import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';

const PageWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    height: 100vh;
    width: 100%;
    overflow: hidden;

    @media (max-width: 768px) {
        flex-direction: column;
        height: auto;
        overflow: auto;
    }
`;

const LeftBanner = styled.div`
    flex: 0 0 45%;
    background: #001F5C;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 64px 48px;
    position: relative;
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 1px;
        height: 100%;
        background: rgba(0, 184, 212, 0.1);
    }

    @media (max-width: 768px) {
        flex: 0 0 auto;
        min-height: 250px;
        padding: 48px 32px;

        &::after {
            display: none;
        }
    }
`;

const BannerContent = styled.div`
    max-width: 420px;
    text-align: center;

    img {
        max-width: 280px;
        height: auto;
        margin-bottom: 48px;
        filter: brightness(0) invert(1);
    }

    h1 {
        font-size: 2rem;
        font-weight: 600;
        margin-bottom: 16px;
        color: #ffffff;
        letter-spacing: -0.02em;

        @media (max-width: 768px) {
            font-size: 1.75rem;
        }
    }

    p {
        font-size: 1rem;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.7);
        font-weight: 400;
    }
`;

const RightContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100vh;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    @media (max-width: 768px) {
        height: auto;
        overflow-y: visible;
    }
`;

const ContentInner = styled.div`
    padding: 64px 48px;
    width: 100%;
    max-width: 900px;
    margin: 0 auto;

    @media (max-width: 768px) {
        padding: 32px 24px;
    }
`;

const OutletWrapper = styled(Card)`
    width: 100%;
    border-radius: 12px;
    border: 1px solid #e8e8e8;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    background-color: #ffffff;

    .ant-card-head {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 24px;
        font-weight: 600;
    }

    .ant-card-body {
        padding: 32px 24px;
    }
`;

const UIOutlet = ({ children, title, extra, style, bannerTitle, bannerDescription, logoSrc }) => {
    return (
        <PageWrapper>
            <LeftBanner>
                <BannerContent>
                    {logoSrc && <img src={logoSrc} alt="Logo" />}
                    <h1>{bannerTitle || 'Welcome'}</h1>
                    <p>{bannerDescription || 'Fill out the form to get started with your journey.'}</p>
                </BannerContent>
            </LeftBanner>

            <RightContent>
                <ContentInner>
                    <OutletWrapper title={title} extra={extra} style={style}>
                        {children}
                    </OutletWrapper>
                </ContentInner>
            </RightContent>
        </PageWrapper>
    );
};

export default UIOutlet;